import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import PlayerSelectDialog from '../player/PlayerSelectDialog';
import { Typography } from '@mui/material';


const PlayerSelectPanel = ({ defaultPlayer, onSelect, onClear }) => {
    const [player, setPlayer] = useState(() => {
        return defaultPlayer ? { ...defaultPlayer } : null
    });

    useEffect(() => {
        setPlayer(defaultPlayer);
    }, [defaultPlayer]);

    const [showPlayerSelectDialog, setShowPlayerSelectDialog] = useState(false);

    const handlePlayerSelect = (player) => {
        setShowPlayerSelectDialog(false);
        setPlayer(player);
        onSelect(player);
    };

    const handleClearPlayer = () => {
        setPlayer(null);
        onClear();
    };

    return (
        <>
            {showPlayerSelectDialog && <PlayerSelectDialog onSelect={handlePlayerSelect} onClose={() => setShowPlayerSelectDialog(false)} />}
            <Stack spacing={1} direction="row">
                <Typography variant="body1" color="textSecondary">
                    Player:
                </Typography>
                <Typography variant="body1" color="textPrimary">
                    {player?.ign || ''}
                </Typography>
                <Button variant='contained' size="small" onClick={() => setShowPlayerSelectDialog(true)}>
                    {player ? 'Change Player' : 'Link Player'}
                </Button>
                {player && <Button variant='outlined' size="small" onClick={handleClearPlayer}>
                    Remove Player
                </Button>}
            </Stack>
        </>
    );
};

export default PlayerSelectPanel;
